import * as dcommJS from '@dcomm-tech/dcomm-js'

const networks = require('../src/config.ts')

// const selectedNetwork = window.location.pathname.split('=')
const queryString = window.location.search
const urlParams = new URLSearchParams(queryString)
let selectedNetwork = urlParams.get('network') || ''

let foundNetName = false
// if (selectedNetwork.length > 1) {
//     if (selectedNetwork[1].length > 17) {
//         window.location.replace('/network=mainnet')
//     }
// }
networks.networks.map((net: any) => {
    if (selectedNetwork.length <= 1) {
        selectedNetwork = 'mainnet'
        window.location.replace('/?network=mainnet')
    }
    if (net.name === selectedNetwork.toLowerCase()) {
        localStorage.setItem('CurrentNetwork', JSON.stringify(net))
        foundNetName = true
        return
    }
})

// networks.map((net: any) => {
//     if(searchParams.get('network') === net.name){
//         localStorage.setItem('CurrentNetwork', JSON.stringify(net))
//         foundNetName = true
//         return
//     }
// })
if (!foundNetName) {
    window.location.replace('/?network=mainnet')
}

const currentNetwork = JSON.parse(
    localStorage.getItem('CurrentNetwork') || '{}'
)

// const DEFAULT_NETWORK_ID = parseInt(currentNetwork.network_id)

let PROTOCOL = ''
let IP = ''
let PORT = 80
let NETWORK_ID = 0
let CHAIN_ID = 'AST'

PROTOCOL = currentNetwork.protocol as string
IP = currentNetwork.ip as string
PORT = parseInt(currentNetwork.port as string)
NETWORK_ID = parseInt(currentNetwork.networkId as string)
CHAIN_ID = currentNetwork.chainId as string
const dcomm = new dcommJS.Dcomm(IP, PORT, PROTOCOL, NETWORK_ID, CHAIN_ID)
const dvm = dcomm.ASTChain()
const authority = dcomm.ATHChain()

export { dcomm, dvm, authority }
